import React from 'react';
import CompanyDetailsScreen from './screens/CompanyDetailsScreen/CompanyDetailsScreen';

function WelcomeDetails() {
  return <CompanyDetailsScreen />;
}

export default WelcomeDetails;
